import CURPSearch from './CURPSearch';

export default CURPSearch;
